import React from 'react';
import { Helmet } from 'react-helmet-async';
import ContactForm from '../components/ContactForm';
// watermark applied via CSS background in App.css; no direct import needed here
import { FaFacebook, FaInstagram } from 'react-icons/fa';

const Contact = () => (
  <section className="contact-section-enhanced" id="contact">
    <Helmet>
      <title>Contact | Lawns Out West</title>
      <meta name="description" content="Contact Lawns Out West for lawn mowing, garden care and free quotes across Melbourne's West. Phone 0423 358 158." />
    </Helmet>
    <div className="container">
      <div className="contact-intro">
        <h2 className="contact-main-title">Ready to Transform Your Outdoor Space?</h2>
        <p className="contact-subtitle">Get your free quote today – no obligation, just honest advice and competitive pricing.</p>
      </div>
      
      <div className="contact-content">
        <div className="contact-form-wrapper">
          <div className="contact-form-card">
            <h3>Send us a message</h3>
            <ContactForm />
          </div>
        </div>
        
        <div className="contact-info-enhanced">
          <h3>Get in Touch Directly</h3>
          <div className="contact-methods">
            <div className="contact-method">
              <div className="contact-method-icon">📞</div>
              <div>
                <strong>Call or Text</strong>
                <a href="tel:0423358158" className="contact-method-link">0423 358 158</a>
              </div>
            </div>
            
            <div className="contact-method">
              <div className="contact-method-icon">✉️</div>
              <div>
                <strong>Email Us</strong>
                <a href="mailto:lawnsoutwest@outlook.com" className="contact-method-link">lawnsoutwest@outlook.com</a>
              </div>
            </div>
            
            <div className="contact-method">
              <div className="contact-method-icon">📍</div>
              <div>
                <strong>Service Areas</strong>
                <span className="service-areas-text">Melton, Bacchus Marsh, Hillside, Taylors Lakes, Keilor, Fraser Rise, Taylors Hill, Delahey, St Albans, Sunshine Nth, Sunshine, Altona Nth, Altona Meadows, Point Cook, Hoppers Crossing, Werribee, Wyndham Vale, Manor Lakes, Eynesbury, Caroline Springs, Thornhill Park.</span>
              </div>
            </div>
          </div>
          
          <div className="social-section">
            <h4>Follow Our Work</h4>
            <div className="social-links-enhanced">
              <a href="https://www.facebook.com/LawnsOutWest" target="_blank" rel="noreferrer" className="social-link">
                <FaFacebook /> Facebook
              </a>
              <a href="https://www.instagram.com/lawnsoutwest" target="_blank" rel="noreferrer" className="social-link">
                <FaInstagram /> Instagram
              </a>
            </div>
          </div>
          
          <div className="contact-cta">
            <a href="tel:0423358158" className="contact-cta-button">📞 Call Now for Immediate Service</a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Contact;


